module.exports = __webpack_public_path__ + "img/start.7c70158b.jpg";